
import Vue from 'vue'

export default Vue.extend({
  props: {
    /**
     * * Состояние загрузки
     */
    isLoading: {
      type: Boolean,
      default: false
    },

    /**
     * * Можно ли нажать на кнопку ?
     */
    canSubmit: {
      type: Boolean,
      default: true
    },

    /**
     * * Фиксированная ширина ?
     */
    isFixed: {
      type: Boolean,
      default: false
    },

    /**
     * * Классы для кнопки
     */
    className: {
      type: String,
      default: ''
    }
  }
})
